import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Styles} from "../../../../config/design/styles";
import {Translate} from "../../../../config/Translate";
import FileManagerDialog from "./FileManagerDialog";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import DefaultImage from '../../../../files/img/default.jpg';
import DefaultAvatar from '../../../../files/img/user-default.jpg';
import { withSnackbar } from 'notistack';
import Avatar from "@material-ui/core/Avatar/Avatar";
import Badge from "@material-ui/core/Badge/Badge";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import Typography from "@material-ui/core/Typography/Typography";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';

class Thumbnail extends React.Component{
    state = {
        FileManagerPending: false,
        image: this.props.avatar ? DefaultAvatar : DefaultImage,
        init: this.props.initial,
        id: this.props.initial
    };
    classes = this.props.classes;
    size = this.props.size ? this.props.size: 245;
    image_ = this.size > 240 ? !!this.props.avatar ? "_small" :  "_medium" : "_small";
    componentDidMount(){
        this.loadData()
    }

    loadData(){
        let id = this.state.init;
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/file/get`, data, config)
            .then(response => {
                this.setState({
                    image: `${defaultVariabls.uploads}/FileManager/${response.data.name}${this.image_}.${response.data.extension}`,
                    init: id,
                    id: response.data.id,
                })
                this.props.handleThumbImage(response.data.id)
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.loadingThumbnailFailed, {
                    variant: 'error',
                });
            });
    }
    toggleOperation= () => {
        this.setState({
            FileManagerPending:!this.state.FileManagerPending,
        })
    }
    setDefaultImage(){
        this.setState({
            image: DefaultImage
        })
    }
    setImage = (data) => {
        this.setState({
            image: data.thumbSource,
            id: data.id
        })
        this.props.handleThumbImage(data.id)
        this.toggleOperation();
    }
    handleDefaultImage(){
        let check = this.props.avatar;
        if(check){
            this.setState({
                image: DefaultAvatar,
                id:2,
            })
            this.props.handleThumbImage(2)
        }else{
            this.setState({
                image: DefaultImage,
                id:1,
            })
            this.props.handleThumbImage(1)
        }
    }
    render(){

        let {FileManagerPending,image,id} = this.state;
        let {title,rounded,noHelper} = this.props;
        return (
            <div style={{textAlign:"center"}}>
                <Badge
                    className="withCursor"
                    overlap="circle"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    badgeContent={<Avatar onClick={this.toggleOperation} style={{backgroundColor:"#ffb63e"}} alt={Translate.changeImage} > <EditRoundedIcon/> </Avatar>}
                >
                    <Avatar
                        alt={title ? title : Translate.ThumbnailTitle}
                        src={image}
                        variant={rounded ? "rounded" : "circle"}
                        onClick={this.toggleOperation}
                        style={{
                            width: this.size,
                            height: this.props.avatar ? this.size : this.size > 240 ? this.size*2/3 : this.size
                        }}>
                        {Translate.appName.charAt(0)}
                    </Avatar>
                    {
                        id !== 1 && id !== 2 ?
                            <IconButton
                                className="thumbnailCloser"
                                onClick = {this.handleDefaultImage.bind(this)}
                            >
                                <CancelRoundedIcon color="secondary"/>
                            </IconButton>
                            : null
                    }
                </Badge>
                {
                FileManagerPending ? <FileManagerDialog size={this.props.size} cancleOperation={this.toggleOperation} setImage={this.setImage}/> : null
                }
                {
                    !!noHelper  ? null :
                    !this.props.avatar ?
                        <Typography gutterBottom color="textSecondary" variant="body2"> {Translate.thumbnailSizeArticle}</Typography>
                    :
                        <Typography gutterBottom color="textSecondary" variant="body2"> {Translate.logoSize600}</Typography>

                }

            </div>
        );
    }
}
export default withSnackbar(withStyles(Styles)(Thumbnail));